<template>
  <div>
    <p v-if="message" class="mb-8 text-lg font-semibold text-center text-orange-400">{{ message }}</p>

    <div class="flex flex-wrap justify-between">
      <button
        :class="{ 'shadow-xl hover:shadow-xl': selection.selected === 1 }"
        class="flex-1 px-6 py-8 mx-4 my-3 transition duration-150 bg-white rounded-lg outline-none md:py-12 hover:shadow-md"
        @click="select(1)"
      >
        <icon
          name="id"
          width="65"
          height="65"
          vbWidth="394"
          vbHeight="394"
          stroke="none"
          :class="{ 'text-orange-400 opacity-100': selection.selected === 1 }"
          class="mb-6 text-gray-600 opacity-50"
        />
        <div
          :class="{ 'text-gray-900 opacity-100': selection.selected === 1 }"
          class="text-xl font-semibold text-gray-600 opacity-50"
        >
          Mobile-ID
        </div>
      </button>

      <button
        :class="{ 'shadow-xl hover:shadow-xl': selection.selected === 2 }"
        class="flex-1 px-6 py-8 mx-4 my-3 transition duration-150 bg-white rounded-lg outline-none md:py-12 hover:shadow-md"
        @click="select(2)"
      >
        <icon
          name="smart"
          width="65"
          height="65"
          vbWidth="65"
          vbHeight="65"
          stroke="none"
          :class="{ 'text-orange-400 opacity-100': selection.selected === 2 }"
          class="mb-6 text-gray-600 opacity-50"
        />
        <div
          :class="{ 'text-gray-900 opacity-100': selection.selected === 2 }"
          class="text-xl font-semibold text-gray-600 opacity-50"
        >
          Smart-ID
        </div>
      </button>

      <button
        v-if="!$root.$data.isMobile"
        :class="{ 'shadow-xl hover:shadow-xl': selection.selected === 3 }"
        class="flex-1 px-6 py-8 mx-4 my-3 transition duration-150 bg-white rounded-lg outline-none md:py-12 hover:shadow-md"
        @click="select(3)"
      >
        <icon
          name="card"
          width="65"
          height="65"
          vbWidth="48"
          vbHeight="42"
          stroke="none"
          :class="{ 'text-orange-400 opacity-100': selection.selected === 3 }"
          class="mb-6 text-gray-600 opacity-50"
        />
        <div
          :class="{ 'text-gray-900 opacity-100': selection.selected === 3 }"
          class="text-xl font-semibold text-gray-600 opacity-50"
        >
          ID-card
        </div>
      </button>

      <button
        v-if="isLogin"
        :class="{ 'shadow-xl hover:shadow-xl': selection.selected === 4 }"
        class="flex-1 px-6 py-8 mx-4 my-3 transition duration-150 bg-white rounded-lg outline-none md:py-12 hover:shadow-md"
        @click="select(4)"
      >
        <i style="font-size: 4rem"
            :class="{ 'text-gray-900 opacity-100': selection.selected === 4 }"
            class="mb-6 opacity-50 text-gray-600 pi pi-key "/>
        <div
          :class="{ 'text-gray-900 opacity-100': selection.selected === 4 }"
          class="text-xl font-semibold text-gray-600 opacity-50"
        >
          Password
        </div>
      </button>
    </div>

    <div class="my-8 md:my-12">
      <transition name="scale" mode="out-in">
        <div v-if="selection.selected === 1" class="max-w-md mx-auto" key="mobileID">
          <div class="flex space-x-6 py-6">
            <input-mask id="phone-code" v-model="selection.phoneCode" mask="+***" prefix="+" class="w-20" />

            <div class="flex-1 p-float-label">
              <input-text
                id="phone"
                placeholder=" "
                v-model="selection.phone"
                :use-grouping="false"
                class="w-full"
              />
              <label for="phone">Telefoni number</label>
            </div>
          </div>
          <div class="flex space-x-6">
            <div class="flex-1 p-float-label">
              <input-number
                id="id-number"
                placeholder=" "
                v-model="selection.idNumber"
                :use-grouping="false"
                class="w-full"
              />
              <label for="id-number">Isikukood</label>
            </div>

            <div class="flex-1 p-float-label">
              <dropdown id="country" v-model="selection.country" :options="countries" class="w-full" />
              <label for="country">Riik</label>
            </div>
          </div>
        </div>

        <div v-if="selection.selected === 2" class="max-w-xl mx-auto" key="smartID">
          <div class="flex space-x-6">
            <div class="flex-1 p-float-label">
              <input-number
                id="id-number"
                placeholder=" "
                v-model="selection.idNumber"
                :use-grouping="false"
                class="w-full"
              />
              <label for="id-number">Isikukood</label>
            </div>

            <div class="flex-1 p-float-label">
              <dropdown id="country" v-model="selection.country" :options="countries" class="w-full" />
              <label for="country">Riik</label>
            </div>
          </div>
        </div>

        <div v-if="selection.selected === 3 && !$root.$data.isMobile" class="max-w-md mx-auto text-center" key="idCard">
          <p class="md:text-lg">ID-kaardiga registreerimiseks palun sisesta ID-kaart lugejasse.</p>
        </div>
        <div v-if="selection.selected === 4 && isLogin" class="max-w-xl mx-auto" key="emailPassword">
          <div class="flex space-x-6">
            <div class="flex-1 p-float-label">
              <input-text
                id="email"
                placeholder=" "
                v-model="selection.email"
                :use-grouping="false"
                class="w-full"
              />
              <label for="email">Email</label>
            </div>

            <div class="flex-1 p-float-label">
              <password
                id="password"
                placeholder=" "
                :feedback="false"
                v-model="selection.password"
                :use-grouping="false"
                class="w-full"
                input-class="w-full"
              />
              <label for="password">Parool</label>
            </div>
          </div>
          <div class="flex items-center justify-center py-6">
            <router-link to="/forgot-password" class="px-6 font-semibold hover:text-blue-500 text-gray-500">
              Unustasid parooli?
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'method', 'isLogin'],
  data() {
    return {
      //message: '',
      selection: {
        selected: null,
        phone: null,
        // phone: '00000766', // automated test demo
        phoneCode: 372,
        idNumber: null,
        // idNumber: 60001019906, // automated test demo
        country: 'Eesti',
        email: null,
        password: null
      },
      countries: ['Eesti', 'Läti', 'Leedu']
    }
  },
  methods: {
    select(e) {
      this.selection.selected = e
      this.$emit('success', this.selection)

      // TWO test accounts
      /* if (e === 2) {
        this.selection.idNumber = 30303039914
      } else {
        this.selection.idNumber = 60001019906
      } */
      // remove after test
    }
  },
  mounted () {
    if (typeof this.method !== 'undefined') {
      this.select(this.method)
    }
  }
}
</script>
